import '@deskworks/tokens/css/deskworks-one.css';
import '@deskworks/ui/styles.css';
import './styles/app.css';
import { Toaster } from '@deskworks/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './app/router.js';
import { SessionProvider } from './app/session.js';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SessionProvider>
      <RouterProvider router={router} />
      <Toaster />
    </SessionProvider>
  </StrictMode>,
);
